var _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9941,
    y: 10.287,
    width: 1,
    height: 13.1339,
    rx: 0.5,
    transform: "rotate(135 10.9941 10.287)",
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.70703,
    y: 10.9942,
    width: 1,
    height: 13.1339,
    rx: 0.5,
    transform: "rotate(-135 1.70703 10.9942)",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopClose);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMiAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTAuOTk0MSIgeT0iMTAuMjg3IiB3aWR0aD0iMSIgaGVpZ2h0PSIxMy4xMzM5IiByeD0iMC41IiB0cmFuc2Zvcm09InJvdGF0ZSgxMzUgMTAuOTk0MSAxMC4yODcpIiBmaWxsPSIjMzMzMzMzIi8+CjxyZWN0IHg9IjEuNzA3MDMiIHk9IjEwLjk5NDIiIHdpZHRoPSIxIiBoZWlnaHQ9IjEzLjEzMzkiIHJ4PSIwLjUiIHRyYW5zZm9ybT0icm90YXRlKC0xMzUgMS43MDcwMyAxMC45OTQyKSIgZmlsbD0iIzMzMzMzMyIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };